module.exports = __webpack_public_path__ + "static/media/co_user_icon_comment.ae9ee57f.svg";